import {
    RT_DB_SEND_NOTIFICATION,
    RT_DB_IS_LISTENING,
    RT_DB_LISTEN_NOTIFICATION
} from '../actions/types'

const initialState = {
    newNotification:null,
    lastCreated: null,
    isListening: false,
    
}

const notificationsReducer = (state = initialState, action) => {
    switch (action.type) {

        case RT_DB_LISTEN_NOTIFICATION: 
            if(state.lastCreated !== action.payload.created_at ){
                var notif ={
                    ...action.payload,
                    ownership: 'others'
                }
                return {
                    ...state,
                    newNotification:notif,
                    lastCreated:action.payload.created_at
                }
            }else{
                console.log('repeated')
            }
          
        case RT_DB_SEND_NOTIFICATION:
            var notif ={
                ...action.payload,
                ownership: 'mine'
            }
            if(state.lastCreated !== action.payload.created_at ){
                return {
                    ...state,
                    newNotification:notif,
                    lastCreated:action.payload.created_at
                } 
            }
       
        case RT_DB_IS_LISTENING:
            return {
                ...state,
                isListening:action.payload
            }   
        default: 
            return state
    }

}

export default notificationsReducer
